import React, { useEffect } from 'react';
import { 
  Calendar, 
  Clock, 
  User, 
  Building2, 
  CreditCard, 
  Users, 
  Map, 
  FileText, 
  UserCog, 
  Landmark, 
  PiggyBank, 
  Keyboard, 
  Phone, 
  MessageCircle,
  Sparkles,
  Target,
  BookOpen,
  Briefcase,
  ShieldCheck,
  Route
} from 'lucide-react';
import styles from './Syllabus.module.css';
import ScrollReveal from 'scrollreveal';

const ReceptionistSyllabus = ({ bgImage }) => {

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.dayCard}`, {
      duration: 1000,
      distance: '50px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      interval: 200,
    });
  }, []);

  const sessions = [
    {
      number: 1,
      title: 'מ"עוזרת" למנהלת אסטרטגית',
      icon: User,
      bgImage: bgImage,
      points: [
        { text: 'נבנה את הזהות המקצועית שלך', icon: Sparkles },
        { text: 'נבין את ההבדל הקריטי בין מזכירה למנהלת אדמיניסטרציה', icon: Building2 },
        { text: 'נגדיר בדיוק למי את עוזרת ואיך', icon: Target }
      ]
    },
    {
      number: 2,
      title: 'יציקת היסודות והפיננסים',
      icon: Landmark,
      bgImage: bgImage,
      points: [
        { text: 'בונים את התשתית החוקית והעסקית', icon: FileText },
        { text: 'נבין את גבולות האחריות שלך', icon: ShieldCheck },
        { text: 'נתחיל לבנות את "מפת היסודות" של העסק החדש שלך', icon: Landmark }
      ]
    },
    {
      number: 3,
      title: 'המנוע הרווחי – תמחור וכסף',
      icon: CreditCard,
      bgImage: bgImage,
      points: [
        { text: 'נלמד איך הופכים שעות לכסף', icon: PiggyBank },
        { text: 'תרגול פרקטי באקסל', icon: Keyboard },
        { text: 'בחירת מודל רווחיות', icon: Briefcase },
        { text: 'בניית הצעות מחיר שאי אפשר לסרב להן', icon: CreditCard }
      ]
    },
    {
      number: 4,
      title: 'קליטת לקוח כמו מקצוענית',
      icon: Users,
      bgImage: bgImage,
      points: [
        { text: 'איך מתחילים עבודה עם לקוח חדש בלי בלאגן?', icon: Users },
        { text: 'הצבת גבולות', icon: ShieldCheck },
        { text: 'זיהוי נורות אזהרה', icon: Phone },
        { text: 'ניהול תקשורת שבונה הערכה מהרגע הראשון', icon: MessageCircle }
      ]
    },
    {
      number: 5,
      title: 'יוצאות לדרך עם תוכנית עבודה',
      icon: Route,
      bgImage: bgImage,
      points: [
        { text: 'סיכום התהליך', icon: BookOpen },
        { text: 'בניית "מפת דרכים" אישית', icon: Map },
        { text: 'את יוצאת לשוק לא רק עם ידע, אלא עם צעדים ראשונים לכיבוש היעד הבא שלך', icon: Target }
      ]
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h1 className={styles.title}>קורס ניהול אדמיניסטרציה לעסקים</h1>
        </div>

        <div className={styles.infoGrid}>
          <div className={styles.infoCard}>
            <div className={styles.infoIcon}>
              <Calendar size={22} color="#FFFFFF" />
            </div>
            <div className={styles.infoText}>5 מפגשים</div>
          </div>
          
          <div className={styles.infoCard}>
            <div className={styles.infoIcon}>
              <Clock size={22} color="#FFFFFF" />
            </div>
            <div className={styles.infoText}>3.5 שעות לכל מפגש</div>
          </div>
        </div>

        <div className={styles.daysContainer}>
          {sessions.map((session, sessionIndex) => {
            const SessionIcon = session.icon;
            return (
              <div 
                key={sessionIndex} 
                className={styles.dayCard}
                style={session.bgImage ? { '--bg-image': session.bgImage } : {}}
              >
                <div className={styles.dayHeader}>
                  <div className={styles.dayNumber}>{String(session.number).padStart(2, '0')}</div>
                  <h2 className={styles.dayTitle}>{session.title}</h2>
                </div>
                
                <div className={styles.itemList}>
                  {session.points.map((point, pointIndex) => {
                    const PointIcon = point.icon;
                    return (
                      <div key={pointIndex} className={styles.item}>
                        <div className={styles.itemIcon}>
                          <PointIcon className={styles.lucideIcon} />
                        </div>
                        <div className={styles.itemText}>{point.text}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReceptionistSyllabus;